import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetPostalcode2 } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';

// Columns to export
export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'postalcode', fieldTitle: t('Τ.Κ.'), fieldType: 'TEXT' },
    { fieldName: 'area', fieldTitle: t('Περιοχή'), fieldType: 'TEXT' },
    { fieldName: 'city', fieldTitle: t('Πόλη'), fieldType: 'TEXT' },
    { fieldName: 'county', fieldTitle: t('Νομός'), fieldType: 'TEXT' },
    { fieldName: 'region', fieldTitle: t('Περιφέρεια'), fieldType: 'TEXT' },
    { fieldName: 'country', fieldTitle: t('Χώρα'), fieldType: 'TEXT' },
    { fieldName: 'isActiveText', fieldTitle: t('Ενεργό'), fieldType: 'TEXT' },
    { fieldName: 'firstDate', fieldTitle: t('Ημερ. Δημιουργίας'), fieldType: 'DATETIME' },
    { fieldName: 'lastDate', fieldTitle: t('Ημερ. Τροποποίησης'), fieldType: 'DATETIME' },
    { fieldName: 'firstUser', fieldTitle: t('Δημιουργήθηκε από'), fieldType: 'TEXT' },
    { fieldName: 'lastUser', fieldTitle: t('Τροποποιήθηκε από'), fieldType: 'TEXT' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetPostalcode2, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = (data?.getPostalcode2Fotokiklosi?.data ?? []).map((v) => ({
        ...v,
        isActiveText: v.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
      }));

      const trsData = {
        getPostalcode2Fotokiklosi: {
          data: recs,
          recordCount: data?.getPostalcode2Fotokiklosi?.recordCount ?? recs.length,
        },
      };

      setResult([get, { loading, data: trsData }]);
    }

    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('Εξαγωγή Ταχυδρομικών Κωδικών'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables,
  });
}
